import React from 'react'

export interface TimeoutErrorProps {
  title?: string
  description?: string
  isLoadMoreError?: boolean
}

export const TimeoutError: React.FC<TimeoutErrorProps> = ({ title, description, isLoadMoreError = false }) => {
  return (
    <div 
      className={`cmp-filterable-list--emptynews cmp-filterable-list--timeout ${isLoadMoreError ? 'cmp-filterable-list--timeout-loadmore' : ''}`}
      data-backend-timeout="true"
    >
      <div className="cmp-filterable-list--timeout-icon">
        <svg viewBox="0 0 40 34.6" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M20 0L0 34.6h40L20 0z" fill="none" stroke="#CE0000" strokeWidth="2" />
          <path d="M20 10v10" stroke="#CE0000" strokeWidth="2.5" strokeLinecap="round" />
          <circle cx="20" cy="27" r="1.5" fill="#CE0000" />
        </svg>
      </div>
      <div>
        <p className="cmp-filterable-list--emptynews-message">{title}</p>
        {!isLoadMoreError && description && (
          <p className="cmp-filterable-list--emptynews-description">{description}</p>
        )}
      </div>
    </div>
  )
}
